// extracted by mini-css-extract-plugin
export default {"struck":"BQ9AFf","priceStack":"W2Y84E","positivePrice":"VzSoAt","pricePerception":"dn_zhP","infoIcon":"jG2DfJ"};